import { MODAL_OPEN_PAYMENT,
         MODAL_CLOSE_PAYMENT,
         MODAL_ADD_ORDER_ID,
         MODAL_ADD_ITEM_ID,
         MODAL_ADD_CURRENTORDER_ITEM_ID,
         MODAL_OPEN_ORDERNAME,
         MODAL_CLOSE_ORDERNAME,
         MODAL_OPEN_ORDERNOTE,
         MODAL_CLOSE_ORDERNOTE,
         MODAL_OPEN_ORDERDISCOUNT,
         MODAL_CLOSE_ORDERDISCOUNT,
         MODAL_OPEN_ORDERCLOSE,
         MODAL_CLOSE_ORDERCLOSE,
         MODAL_OPEN_ORDERLOCATION,
         MODAL_CLOSE_ORDERLOCATION,
         MODAL_OPEN_ITEMMODIFIER,
         MODAL_CLOSE_ITEMMODIFIER,
         MODAL_OPEN_ITEMNOTE,
         MODAL_CLOSE_ITEMNOTE,
         MODAL_OPEN_PUNCH,
         MODAL_CLOSE_PUNCH,
         MODAL_RESET,
         SET_NEXT_MODAL,
         CLEAR_NEXT_MODAL,
       } from '../actions/index';

let initialState = {
  "showPaymentModal": false,
  "showOrderNameModal": false,
  "showOrderNoteModal": false,
  "showOrderDiscountModal": false,
  "showOrderCloseModal": false,
  "showOrderLocationModal": false,
  "showItemModifierModal": false,
  "showItemNoteModal": false,
  "showPunchModal": false,
  "nextModal": '',
  "modalOrderID": '',
  "modalItemID": {},
  "modalCurrentOrderItemID": '',
};

export default function(state = initialState, action) {
  switch(action.type) {
    case MODAL_OPEN_PAYMENT:
      return { ...state, showPaymentModal: true };
    case MODAL_CLOSE_PAYMENT:
      return { ...state, showPaymentModal: false };
    case MODAL_ADD_ORDER_ID:
      return { ...state, modalOrderID: action.id };
    case MODAL_ADD_CURRENTORDER_ITEM_ID:
      return { ...state, modalCurrentOrderItemID: action.id };
    case MODAL_ADD_ITEM_ID:
      return { ...state,
        modalItemID: {
          categoryID: action.categoryID,
          itemID: action.itemID,
        }
      };
    case MODAL_OPEN_ORDERNAME:
      return { ...state, showOrderNameModal: true };
    case MODAL_CLOSE_ORDERNAME:
      return { ...state, showOrderNameModal: false };
    case MODAL_OPEN_ORDERNOTE:
      return { ...state, showOrderNoteModal: true };
    case MODAL_CLOSE_ORDERNOTE:
      return { ...state, showOrderNoteModal: false };
    case MODAL_OPEN_ORDERDISCOUNT:
      return { ...state, showOrderDiscountModal: true };
    case MODAL_CLOSE_ORDERDISCOUNT:
      return { ...state, showOrderDiscountModal: false };
    case MODAL_OPEN_ORDERCLOSE:
      return { ...state, showOrderCloseModal: true };
    case MODAL_CLOSE_ORDERCLOSE:
      return { ...state, showOrderCloseModal: false };
    case MODAL_OPEN_ORDERLOCATION:
      return { ...state, showOrderLocationModal: true };
    case MODAL_CLOSE_ORDERLOCATION:
      return { ...state, showOrderLocationModal: false };
    case MODAL_OPEN_ITEMMODIFIER:
      return { ...state, showItemModifierModal: true };
    case MODAL_CLOSE_ITEMMODIFIER:
      return { ...state, showItemModifierModal: false };
    case MODAL_OPEN_ITEMNOTE:
      return { ...state, showItemNoteModal: true };
    case MODAL_CLOSE_ITEMNOTE:
      return { ...state, showItemNoteModal: false };
    case MODAL_OPEN_PUNCH:
      return { ...state, showPunchModal: true };
    case MODAL_CLOSE_PUNCH:
      return { ...state, showPunchModal: false };
    case SET_NEXT_MODAL:
      return { ...state, nextModal: action.modal};
    case CLEAR_NEXT_MODAL:
      return { ...state, nextModal: '' };
    case MODAL_RESET:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_modals.js